import script from "./ResultForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultForm.vue?vue&type=script&setup=true&lang=js"

import "./ResultForm.vue?vue&type=style&index=0&id=74713b50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74713b50"]])

export default __exports__